import { Form, Input, Button, Typography, Select } from "antd";
import { useState } from "react";
import useLoteConsultaAPI, { RegenerarModel } from "./useLotesImpresionAPI";
import MainLayout from "../common/components/MainLayout";
import Paragraph from "antd/lib/typography/Paragraph";
import options from "./components/RegenerarOptions";

const Regenerar = () => {
    const [archivo, setArchivo] = useState([]);
    const [send, setSend] = useState<boolean>(false);
    const [okMessage, setOkMessage] = useState<string>('')
    const [error, setError] = useState<string>('');
    const [estado, setEstado] = useState<number>(8);
    const [loadingSendFile, setLoadingSendFile] = useState<boolean>(false);

    const api = useLoteConsultaAPI();
    const subirArchivo = (e: any) => {
        setArchivo(e);
    };
    const handleSubmit = () => {
        setLoadingSendFile(true);
        let data = new FormData();
        data.append("file", archivo[0])
        data.append('estado', `${estado}`);
        api.sendFile(data).then(response => {
            setSend(true);
            setOkMessage(`Se ${response.count === 1 ? 'proceso' : 'procesaron'} ${response.count} ${response.count === 1 ? 'infracción' : 'infracciones'} correctamente.`)
            setTimeout(() => {
                setSend(false);
            }, 5000);
        }).catch(error => {
            const message = error.response?.data ?? error.message      
            setError(message);
            setTimeout(() => {
                setError('')
            }, 5000);
        }).finally(()=>{ setLoadingSendFile(false); }
        );
        
    };
    return (
        <MainLayout title="Regenerar Actas">
            <div style = {{ marginBottom: "25px" }}>
                <Typography style={{textAlign:'justify'}}>
                    <Paragraph>
                        A continuación podrá volver las infracciones desde el estado <strong> 'Impresión Generada'</strong> a <strong>'Verificadas'</strong> o <strong>'Renombradas'</strong>. En este estado de verificación se puede volver a imprimir por lote.
                    </Paragraph>
                    <Paragraph>
                        El archivo de texto deberá contener cualquiera de los dos formatos, similar al emitido por lotes de impresión (archivo txt de lote) o al remitido por el call center:
                    </Paragraph>
                </Typography>
                <Typography>
                    <Paragraph style={{backgroundColor: 'aliceblue', padding: '0.5em 0.5em 0.5em 0', fontSize: 'smaller'}}>
                        AN000001234;NOMBRE Y APELLIDO;CUIT;PROVINCIA;LOCALIDAD;CP;DIRECCION
                    </Paragraph>
                    <Paragraph style={{backgroundColor: 'aliceblue', fontSize: 'smaller'}}>
                        ------------------------------------------------------------------------------------------
                    </Paragraph>
                    <Paragraph style={{backgroundColor: 'aliceblue', fontSize: 'smaller'}}>
                        AN000001234                        
                    </Paragraph>
                    <Paragraph style={{backgroundColor: 'aliceblue', fontSize: 'smaller'}}>                        
                        AN000001235                        
                    </Paragraph>
                    <Paragraph style={{backgroundColor: 'aliceblue', fontSize: 'smaller'}}>
                        AN000001236
                    </Paragraph>
                </Typography>
            </div>            
            <div>
                <Form.Item
                    rules={[
                        { required: true, message: "Campo requerido" }
                    ]}
                    required
                    name={"Estado"}
                    label="Estado"
                >
                <Select
                    optionFilterProp="children"                    
                    allowClear
                    size = "middle"
                    style = {{ width: "25%" }}
                    onChange = {(e) => setEstado(e)}
                    defaultValue = { estado }
                >
                    {
                        options.map(e => 
                            <Select.Option key={e.ID} value= {e.VALUE}>{ e.NOMBRE }</Select.Option>
                        )
                    }
                </Select>
                </Form.Item>
                <Form.Item>
                    <Input type = "file" name = "files" accept=".txt" onChange = {(e) => subirArchivo(e.target.files)} style = {{ width: "40%" }}/>
                    <br/><br/>
                    <Button onClick = { handleSubmit } type="primary" loading={loadingSendFile}>Regenerar actas</Button>
                </Form.Item>
                <Form.Item>
                    <br/>   
                    { send ? <p style = {{ color: "black" }}>{okMessage}</p> : "" }
                </Form.Item>
                <Form.Item>
                    <br/>
                    { error != '' ? <p style = {{ color: "red" }}>{error}</p> : "" }
                </Form.Item>
            </div>
        </MainLayout>
    )
};

export default Regenerar;